import React from "react"
import { Link } from "gatsby"

import { ThemeToggler } from 'gatsby-plugin-dark-mode'
import { IoMdMoon, IoMdSunny } from 'react-icons/io'

import '../styles/header.css'

class Header extends React.Component {
	render() {
		return (
      <nav id="nav">
        <h1 id="logo">
          <Link className="header-link"
            style={{
              boxShadow: `none`,
              textDecoration: `none`,
              color: `inherit`,
            }}
            to={`/`}
          >
           	Amy Henning
          </Link>

        </h1>
        <ul id="nav-links">
          <li><Link className="header-link nav" to={`/`}>Home</Link></li>
          <li><Link className="header-link nav" to={`/about`}>About</Link></li>
          <li><Link className="header-link nav" to={`/blog`}>Blog</Link></li>
          <li><Link className="header-link nav" to={`/work`}>Work</Link></li>
          <li><Link className="header-link nav" to={`/contact`}>Contact</Link></li>
          <li>
            <ThemeToggler>
              {({ theme, toggleTheme }) => (
                <label>
                  <input
                    type="checkbox"
                    onChange={e => toggleTheme(e.target.checked ? 'dark' : 'light')}
                    checked={theme === 'dark'}
                    id="dark-mode-checkbox"
                  />
                  { theme === 'dark' ?
                    <IoMdSunny className="toggle-dark-mode" /> :
                    <IoMdMoon className="toggle-dark-mode" />
                  }
                </label>
              )}
            </ThemeToggler>
          </li>
        </ul>
      </nav>
    )
	}
}

export default Header;
